// Use getter to avoid circular dependency issues during module initialization
export const API_CONFIG = {
    get BASE_URL() {
        return import.meta.env.VITE_API_URL || '';
    },
    ENDPOINTS: {
        TRAINING_RESULTS: '/api/training/results',  // DEPRECATED - use TRAINING_RESULTS_SUMMARY
        TRAINING_RESULTS_SUMMARY: '/api/training/results-summary',  // Lightweight metadata only
        VISUALIZATIONS: '/api/training/visualizations',  // For violin plots
        SESSION_STATUS: '/api/training/session-status',
        TRAINING_STATUS: '/api/training/status',
        CREATE_DATABASE_SESSION: '/api/training/create-database-session',
        SAVE_TIME_INFO: '/api/training/save-time-info',
        SAVE_ZEITSCHRITTE: '/api/training/save-zeitschritte',
        TRAIN_MODELS: '/api/training/train-models',
        GET_TRAINING_STATUS: '/api/training/get-training-status',
        GET_TRAINING_RESULTS: '/api/training/get-training-results'  // DEPRECATED
    }
} as const;

export const POLLING_CONFIG = {
    DATASET_GENERATION_INTERVAL: 5000,
    MODEL_TRAINING_INTERVAL: 10000,
    ANALYSIS_STATUS_INTERVAL: 10000,
    MAX_POLLING_ATTEMPTS: 100,
    TIMEOUT_MINUTES: 5
} as const;

export const DEFAULT_MODEL_CONFIG = {
    MODE: 'Dense' as const,
    LAY: 3,
    N: 512,
    EP: 20,
    ACTF: 'ReLU' as const,
    K: 3,
    KERNEL: 'rbf' as const,
    C: 1.0,
    EPSILON: 0.1
};

export const DEFAULT_TRAINING_SPLIT = {
    n_train: 0,
    n_val: 0,
    n_test: 0,
    random_dat: true,
    trainPercentage: 70,
    valPercentage: 20,
    testPercentage: 10
};

// Types are defined in src/features/training/types/index.ts
// Import from there: import { WorkflowStep, AnalysisStatus, TrainingStatus } from '../types';